import { autogrow, hideWhenCreatingAndEditing, hideWhenDisplaying, hideWhenDisplayingInNonTable, inlineEdit, isInteger } from 'src/types/columnFlags';
import getDistinctValuesOfField from '../distinctValues/getDistinctValuesOfField';
export const row_menu = (col) => (Object.assign({ name: 'row_menu', type: 'row_menu', style: 'width:20px', hideWhenCreatingAndEditing,
    hideWhenDisplayingInNonTable }, (col || {})));
export const id = (col) => {
    const baseColumn = Object.assign({ name: 'id', style: 'width:30px;max-width:50px;', cellContentClasses: 'monospace muted', thClasses: 'monospace muted', isInteger,
        hideWhenCreatingAndEditing, displayValueGetter: (cellProps) => {
            const val = cellProps.row.id;
            if (val && String(val).length > 10) {
                return String(val).slice(0, 3) + '…';
            }
            else {
                return String(cellProps.row.id);
            }
        }, tooltipContent: (cellProps) => `<code>${String(cellProps.row.id)}</code>`, tooltipContentIsHTML: true, maxLines: 1 }, (col || {}));
    return baseColumn;
};
export const uuidColumn = (col) => {
    const baseColumn = Object.assign({ name: 'uuid', style: 'width:30px;max-width:50px;', cellContentClasses: 'monospace muted', thClasses: 'monospace muted', hideWhenCreatingAndEditing, displayValueGetter: (cellProps) => {
            const val = cellProps.row.uuid;
            if (val && String(val).length > 10) {
                return String(val).slice(0, 3) + '…';
            }
            else {
                return String(cellProps.row.uuid);
            }
        }, hideWhenDisplaying, tooltipContent: (cellProps) => `<code>${String(cellProps.row.uuid)}</code>`, tooltipContentIsHTML: true, maxLines: 1 }, (col || {}));
    return baseColumn;
};
export const name = (col) => {
    return Object.assign({ name: (col === null || col === void 0 ? void 0 : col.name) || 'name', style: 'width:35%', inlineEdit: true, autofocus: true }, (col || {}));
};
export const description = (col) => {
    return Object.assign({ name: (col === null || col === void 0 ? void 0 : col.name) || 'description', style: 'width:65%;padding-bottom:5px;padding-top:5px;', inlineEdit,
        autogrow, maxLines: 3 }, (col || {}));
};
export const orgColumn = (col) => {
    return Object.assign({ name: (col === null || col === void 0 ? void 0 : col.name) || 'org_id', references: 'orgs.orgs', cellDivClasses: 'org-label', maxLines: 1, preferredSelectorDialogType: 'treeLookup' }, col);
};
export const userColumn = (col = {}) => {
    return Object.assign({ name: 'user_id', style: 'font-family:monospace;', references: 'users.users' }, col);
};
export const currencyCodeColumn = (col = {}) => {
    return Object.assign({ name: 'currency_code', style: 'font-family:monospace;', references: getDistinctValuesOfField('currency.isoCodes', 'letter_code') }, col);
};
export const detailsColumn = (col) => {
    return Object.assign({ name: (col === null || col === void 0 ? void 0 : col.name) || 'details', isCode: true, codeLanguage: 'JSON', maxLines: 1, hideWhenCreatingAndEditing,
        hideWhenDisplaying, cellDivStyles: { maxWidth: '100px' } }, (col || {}));
};
